function numberFormat(number, decimals, dec_point, thousands_sep) {
  　　/*
  　　 * 参数说明：
  　　 * number：要格式化的数字
  　　 * decimals：保留几位小数
  　　 * dec_point：小数点符号
  　　 * thousands_sep：千分位符号
  　　 * */
  　　 number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  　　 var n = !isFinite(+number) ? 0 : +number,
  　　 prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
   　　sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
   　　dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
   　　s = '',
  　　 toFixedFix = function(n, prec) {
   　　　　var k = Math.pow(10, prec);
   　　　　return '' + Math.ceil(n * k) / k;
   　　};

   　　s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  　　 var re = /(-?\d+)(\d{3})/;
  　　 while(re.test(s[0])) {
   　　　　s[0] = s[0].replace(re, "$1" + sep + "$2");
   　　}

   　　if((s[1] || '').length < prec) {
      　　 s[1] = s[1] || '';
       　　s[1] += new Array(prec - s[1].length + 1).join('0');
   　　}
    　　　return s.join(dec);
}
function getV(){//获取浏览器信息
  let agent = navigator.userAgent.toLowerCase();
  let arr = [];
  let system = agent.split(' ')[1].split(' ')[0].split('(')[1];
  arr.push(system);
  let REGSTR_EDGE = /edge\/[\d.]+/gi;
  let REGSTR_IE = /trident\/[\d.]+/gi;
  let OLD_IE = /msie\s[\d.]+/gi;
  let REGSTR_FF = /firefox\/[\d.]+/gi;
  let REGSTR_CHROME = /chrome\/[\d.]+/gi;
  let REGSTR_SAF = /safari\/[\d.]+/gi;
  let REGSTR_OPERA = /opr\/[\d.]+/gi;
  // IE
  if (agent.indexOf('trident') > 0) {
    arr.push(agent.match(REGSTR_IE)[0].split('/')[0]);
    arr.push(agent.match(REGSTR_IE)[0].split('/')[1]);
  }
  // OLD_IE
  if (agent.indexOf('msie') > 0) {
    arr.push(agent.match(OLD_IE)[0].split(' ')[0]);
    arr.push(agent.match(OLD_IE)[0].split(' ')[1]);
  }
  // Edge
  if (agent.indexOf('edge') > 0) {
    arr.push(agent.match(REGSTR_EDGE)[0].split('/')[0]);
    arr.push(agent.match(REGSTR_EDGE)[0].split('/')[1]);
  }
  // firefox
  if (agent.indexOf('firefox') > 0) {
    arr.push(agent.match(REGSTR_FF)[0].split('/')[0]);
    arr.push(agent.match(REGSTR_FF)[0].split('/')[1]);
  }
  // Opera
  if (agent.indexOf('opr') > 0) {
    arr.push(agent.match(REGSTR_OPERA)[0].split('/')[0]);
    arr.push(agent.match(REGSTR_OPERA)[0].split('/')[1]);
  }
  // Safari
  if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
    arr.push(agent.match(REGSTR_SAF)[0].split('/')[0]);
    arr.push(agent.match(REGSTR_SAF)[0].split('/')[1]);
  }
  // Chrome
  if (agent.indexOf('chrome') > 0) {
    arr.push(agent.match(REGSTR_CHROME)[0].split('/')[0]);
    arr.push(agent.match(REGSTR_CHROME)[0].split('/')[1]);
  } else {
    arr.push('未获取到浏览器信息');
  }


  let browserInfo = arr;
  let browse = {
    n:'',
    v:''
  };
  if (browserInfo[1] && browserInfo[2]) {
    browse.n = browserInfo[1];
    browse.v = browserInfo[2];
  } else {
    browse.n = '未获取到浏览器信息';
    browse.v = '未获取到浏览器信息';
  }
  switch (browserInfo[1] +' '+ browserInfo[2]) {
    case 'msie 6.0':
      browse.n = 'Internet Explorer';
      browse.v = '6';
      break;
    case 'msie 7.0':
      browse.n = 'Internet Explorer';
      browse.v = '7';
      break;
    case 'trident 4.0':
      browse.n = 'Internet Explorer';
      browse.v = '8';
      break;
    case 'trident 5.0':
      this.browse.n = 'Internet Explorer';
      this.browse.v = '9';
      break;
    case 'trident 6.0':
      browse.n = 'Internet Explorer';
      browse.v = '10';
      break;
    case 'trident 7.0':
      browse.n = 'Internet Explorer';
      browse.v = '11';
      break;
  }
  return browse;
}
export{
  numberFormat,getV
}


//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = null
// module chunks = 